import React from 'react'
import PropTypes from 'prop-types'
import { SortableElement } from 'react-sortable-hoc'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import { CircularProgress, IconButton } from '@material-ui/core'
import TrashAlt from '@v4/components/common/FAIcons/Light/TrashAlt'
import { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import RadioButton from '../../../../components/RadioButton'
import CheckboxButton from '../../../../components/CheckboxButton'
import DragHandle from '../../../../components/DragHandle'
import { useOptionItem } from './OptionItem.hooks'

const OptionItem = props => {
	const [
		{
			className,
			disabled,
			value,
			label,
			checked,
			shadow,
			useOldCheckboxes,
			editable,
			draggable,
			classes,
			deletable,
			type,
			deleting,
			tabIndex,
			autoFocus,
			placeholder,
		},
		{ handleClick, handleKeyUp, handleLabelEdit, handleDelete, handleLabelFocus },
	] = useOptionItem(props)

	const deleteButton = deletable && (
		<IconButton disabled={deleting} className={classes.deleteButton} onClick={handleDelete} component="span">
			{deleting ? <CircularProgress size={16} classes={{ circle: classes.deleting }} /> : <TrashAlt />}
		</IconButton>
	)

	const labelElement = (
		<>
			{editable ? (
				<EditableHTML
					html={label}
					component="div"
					variant="inherit"
					displayEmpty
					editable={editable}
					placeholder={placeholder}
					editorVariant={EDITOR_VARIANT.SHORT}
					editorValidElements="br,i/em,b/strong,u,span[style],a[*]"
					onChange={handleLabelEdit}
					onFocus={handleLabelFocus}
					autoFocus={autoFocus}
				/>
			) : (
				<EditableHTML html={label} component="div" variant="inherit" />
			)}
			{deleteButton}
		</>
	)

	return (
		<div className={clsx(classes.root, className)}>
			{draggable && <DragHandle className={classes.dragButton} />}
			{
				{
					radio: (
						<RadioButton
							value={value}
							checked={checked}
							disabled={disabled}
							onKeyUp={handleKeyUp}
							onClick={handleClick}
							label={labelElement}
							shadow={shadow}
							useOldCheckboxes={useOldCheckboxes}
							editable={editable}
							tabIndex={tabIndex}
							classes={{
								control: classes.radioControl,
								label: classes.label,
								radio: classes.radio,
							}}
						/>
					),
					checkbox: (
						<CheckboxButton
							value={value}
							checked={checked}
							disabled={disabled}
							onClick={handleClick}
							onKeyUp={handleKeyUp}
							label={labelElement}
							shadow={shadow}
							useOldCheckboxes={useOldCheckboxes}
							editable={editable}
							tabIndex={tabIndex}
							classes={{
								control: classes.checkboxControl,
								label: classes.label,
							}}
						/>
					),
				}[type]
			}
		</div>
	)
}

OptionItem.propTypes = {
	className: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClick: PropTypes.func,
	pending: PropTypes.bool,
	label: PropTypes.node,
	onKeyUp: PropTypes.func,
	checked: PropTypes.bool,
	shadow: PropTypes.bool,
	useOldCheckboxes: PropTypes.bool,
	editable: PropTypes.bool,
	onLabelEdit: PropTypes.func,
	onDelete: PropTypes.func,
	draggable: PropTypes.bool,
	deletable: PropTypes.bool,
	type: PropTypes.oneOf(['radio', 'checkbox']),
	tabIndex: PropTypes.number,
	autoFocus: PropTypes.bool,
	placeholder: PropTypes.string,
}

OptionItem.defaultProps = {
	type: 'radio',
}

export default SortableElement(OptionItem)
